<template>
    <div class="discountPrice">
      <div class="price" v-if="isShowPrice && discountPrice != null">
        <img class="img" :src="union_icon || require('@assets/images/fudou.png')" />
        <span :class="{'num':true,'nomargL':page == 'activeIndex'}">{{((discountPrice || 0) * union_scale).toFixed(2)}}</span>
      </div>
      <div :class="{'discountTags':true,'marginAuto':tipType === 'cart'}" v-if="discount || discountTagShow == 1 || mktTagShow == 1">
        <div :class="{'discountTag':true,borderradio2:mktTagShow != 1}" v-if="discount || discountTagShow == 1">
            <img :src="require('@/assets/images/V1.png')" v-if="discount && (discountTagShow == 1 || mktTagShow == 1)" />
            <img class="vImg" :src="require('@/assets/images/V2.png')" v-if="discount && discountTagShow != 1 && mktTagShow != 1" />
            <em v-if="discountTagShow == 1">{{discount || 0 }}{{TLang('折','my')}}</em>
        </div>
        <div class="mktTag" v-if="mktTagShow == 1"><img :src="require('@/assets/images/vbg1.png')" v-if="discount" />{{TLang('专享价','my')}}</div>
        <el-tooltip class="tagTooltip" effect="dark" :content="tipContent" placement="bottom" v-if="tipType">
            <el-button><img :src="require('@assets/images/deliveryTip.png')" class="tooltipIcon"/></el-button>
        </el-tooltip>
      </div>
    </div>
  </template>
  
  <script>

  export default {
    components: {

    },
    props: {
        // 是否显示折扣价
        isShowPrice:{
            type: Boolean,
            default: function () {
                return true;
            }
        },
        // 折后价格，13.55
        discountPrice:{
            type: Number,
            default: function () {
                return null;
            }
        },
        // 折扣比例，0.8
        discount:{
            type: Number,
            default: function () {
                return null;
            }
        },
        // 折扣标签是否显示（0否、1是
        discountTagShow:{
            type: Number,
            default: function () {
                return null;
            }
        },
        // 活动标签是否显示（0否、1是
        mktTagShow:{
            type: Number,
            default: function () {
                return null;
            }
        },
        // 显示tip icon
        tipType:{
            type:String,
            default:function(){
                return ''
            }
        },
        // 原价
        price:{
            type: Number,
            default:function(){
                return 0
            }
        },
        page:{
            type:String,
            default:function(){
                return ''
            }
        }
    },
    created(){
        
    },
    computed: {
        tipContent(){
            if(this.tipType === 'detail'){
                return `${this.TLang('带有此标记就是特惠价','list')}`;
            }
            if(this.tipType === 'cart'){
                return `${this.TLang('当前售卖价','list')}:${((this.discountPrice || 0) * union_scale).toFixed(2)} ${this.TLang('日常售卖价','list')}:${((this.price || 0) * union_scale).toFixed(2)}`
            }
            return ''
        }
    }
  };
  </script>
  
  <style lang="less" scoped>
  .discountPrice{
      display: flex;
      overflow: hidden;
      .img{
          width: 12px;
          height: 12px;
          vertical-align: baseline;
      }
      .num{
        margin-left: 6px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      .nomargL{
        margin-left: 0;
      }
      .price{
          margin-right: 5px;
      }
      .discountTags{
          display: flex;
          align-items: center;
          border-radius: 2px;
          overflow: hidden;
      }
      .marginAuto{
        margin: auto;
      }
      .discountTag{
          height: 14px;
          display: flex;
          align-items: center;
          border-radius: 2px 0 0 2px;
          overflow: hidden;
          img{
              width: 13px;
              height: 14px;
              vertical-align: middle;
          }
          .vImg{
              width: auto;
          }
          em{
            padding: 0 4px 1px 0;
            font-size: 12px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #FFFFFF;
            background: linear-gradient(331deg, #000000 0%, #464646 100%);
        }
      }
      .mktTag{
        position: relative;
        min-width: 30px;
        padding: 0 3px;
        height: 14px;
        line-height: 14px;
        background: linear-gradient(36deg, #FBE2A9 0%, #E8C172 100%);
        border-radius: 0 2px 2px 0;
        overflow: hidden;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        img{
            position: absolute;
            left:0;
            top:0;
            height:14px;
            width:auto;
        }
      }
      .tagTooltip{
          margin-left: 4px;
          width: 13px;
          height: 13px;
      }
      .borderradio2{
          border-radius: 2px;
          overflow: hidden;
      }
      .tooltipIcon{
          vertical-align: baseline;
      }
  }
  </style>
  